<template>
  <div class="subServerTable">
    <div class="header">
      <span style="margin-right: 10px">{{ $t('快速选择：') }}</span>
      <div v-for="item in tags" :key="item.id" :class="{ active: selectedTags[item.tagsId] }" @click="changeTags(item)">
        {{ item.tagsName }}
      </div>
    </div>
    <div class="body">
      <es-table
        :data="tableData"
        height="400"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        style="width: 100%"
        ref="dataTable"
      >
        <template slot="empty"
          ><es-empty
            style="margin: 25px; color: #999; line-height: 40px"
            :description="$t(`暂无更多数据`)"
            image="data:image/png;base64,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"
          ></es-empty>
        </template>
        <es-table-column type="selection" width="50" :selectable="selectable" v-if="isEdit"></es-table-column>
        <es-table-column type="index" width="50" :label="$t(`序号`)"></es-table-column>
        <es-table-column prop="productName" :label="$t(`服务名称`)"></es-table-column>
        <es-table-column prop="parentPrice" :label="$t(`本订单价格（元/次）`)" v-if="isEdit"></es-table-column>
        <es-table-column prop="shoudPay" :label="isEdit ? $t('被转售方价格（元/次）') : $t('实际价格（元/次）')">
          <template slot-scope="scope">
            <es-input
              :class="{ 'is-error': scope.row.isError }"
              v-model.trim="scope.row.price"
              style="width: 98px"
              @blur="checkPrice(scope.row)"
              :disabled="scope.row.open"
              v-if="isEdit"
            ></es-input>
            <span v-else>
              {{ scope.row.price }}
            </span>
          </template>
        </es-table-column>
      </es-table>
    </div>

    <div class="change-multiple" v-if="isEdit">
      <div>
        {{ $t('设置调价倍数：')
        }}<es-input-number
          v-model="multiple"
          controls-position="right"
          :min="1"
          :max="10"
          @blur="checkMultiple"
          style="width: 100px"
        ></es-input-number>
        <es-button type="text" style="margin: 0 10px" @click="changeMultiple">{{ $t('应用') }}</es-button>
        <es-tooltip :content="$t(`确定后系统将按本订单价格*调价倍数更新被转售方价格`)" placement="top">
          <i class="es-icon-warning" style="color: #999"></i>
        </es-tooltip>
      </div>
      <div style="padding-right: 65px">
        <span>{{ $t('请输入1-10以内的数字，最多1位小数') }}</span>
      </div>
    </div>

    <div class="footer" style="border-top: 1px solid #e4e4e4">
      <div>
        <es-button variant="outline" @click="cancle" v-if="isEdit">{{ $t('取消') }}</es-button>
        <es-button type="primary" @click="sure" v-if="isEdit">{{ $t('确定') }}</es-button>
        <es-button type="primary" @click="cancle" v-else>{{ $t('知道了') }}</es-button>
      </div>
      <div v-if="isEdit && needPassWord">
        <p class="label">{{ $t('签署密码:') }}</p>
        <es-input v-model="signPassword" class="width-200" type="password" :placeholder="$t('请输入签署密码')"></es-input>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

export default {
  props: {
    orderId: String,
    needPassWord: {
      type: Boolean,
      default: false,
    },
    cakeOrderId: {
      type: String,
      default: '',
    },
    checkedTag: {
      type: Object,
      default() {
        return {}
      },
    },
    checkedTable: Array,
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      signPassword: '',
      tableData: [],
      multiple: 2,
      selectedTags: {},
      multipleSelection: [],
      tags: [],
    }
  },
  methods: {
    cancle() {
      this.$emit('cancle')
    },
    checkMultiple() {
      this.multiple = this.multiple.toFixed(1)
    },
    checkPrice(item) {
      const reg = /^([1-9]\d{0,15}|0)(\.\d{1,4})?$/
      if (!reg.test(item.price)) {
        this.$set(item, 'isError', true)
        item.price = ''
        this.$message.closeAll()

        this.$message.error($t('输入价格不符合规范'))

        return
      }
      this.$set(item, 'isError', false)

      if (item.price < item.parentPrice) {
        item.price = ''
        this.$message.closeAll()
        this.$message.error($t('此价格低于本订单价格，不能提交'))
      }
    },
    sure() {
      if (this.multipleSelection.length === 0) {
        this.$message.closeAll()
        this.$message.error($t('还未勾选子服务项'))

        return
      }
      let noPrice = false
      const productIdArr = []
      this.multipleSelection.forEach((item, index) => {
        if (!item.price || item.price < item.parentPrice) {
          noPrice = true
          item.price = ''

          productIdArr.push(item.productId)
        }
      })
      if (noPrice) {
        this.$message.closeAll()
        this.$message.error($t('存在已勾选但未设置被转售方价格的子服务项'))
        this.tableData.forEach(item => {
          if (productIdArr.includes(item.productId)) {
            this.$set(item, 'isError', true)
          } else {
            this.$set(item, 'isError', false)
          }
        })

        return false
      }
      if (!this.signPassword && this.needPassWord) {
        this.$message({
          type: 'info',
          message: $t('请输入签署密码'),
        })

        return
      }
      this.$emit('getServerData', {
        details: this.multipleSelection,
        checkedTag: this.selectedTags,
        signPassword: this.signPassword,
      })
    },
    selectable(row) {
      return !row.open
    },
    selectTable() {
      if (this.checkedTable && this.checkedTable.length > 0) {
        this.tableData.forEach(item => {
          this.checkedTable.forEach(checkedItem => {
            if (checkedItem.productId === item.productId) {
              item.price = checkedItem.price
              this.$nextTick(() => {
                this.$refs.dataTable.toggleRowSelection(item, true)
              })
            }
          })
        })
      } else {
        this.$nextTick(() => {
          this.$refs.dataTable.toggleAllSelection()
        })
      }
    },
    changeTags(item) {
      this.$set(this.selectedTags, item.tagsId, !this.selectedTags[item.tagsId])
    },
    tableRowClassName({ row }) {
      if (row.tagIds && row.tagIds.some(item => this.selectedTags[item])) {
        return 'selected-row'
      }

      return ''
    },
    handleSelectionChange(array) {
      this.multipleSelection = array
    },
    // 获取子服务价格
    getSubChilds() {
      const { cakeOrderId } = this
      const data = {
        cakeOrderId,
      }
      this.$ajax(this.$url.getSubChilds(this.orderId), data).then(res => {
        // 不展示充值子项允许0元计费标签， 过滤价格为0的产品
        if (res.data && res.data.tags) {
          /* i18n-ignore */
          this.tags = res.data.tags.filter(item => item.tagsName !== '充值子项允许0元计费')
        }
        sessionStorage.setItem('tags', JSON.stringify(res.data.tags))
        const productList = res.data.products.filter(item => item.price !== 0)
        this.tableData = this.isEdit ? productList : productList.filter(item => item.open)
        this.selectTable()
      })
    },
    changeMultiple() {
      if (this.multiple < 1 || this.multiple > 10 || !this.multiple) {
        this.$message.error($t('请输入1-10以内的数字，最多1位小数'))

        return
      }
      this.tableData.forEach(item => {
        if (!item.open) {
          this.$set(item, 'isError', false)
          item.price = (this.multiple * item.parentPrice).toFixed(4)
        }
      })
    },
  },
  created() {
    this.selectedTags = JSON.parse(JSON.stringify(this.checkedTag))

    this.getSubChilds()
  },
}
</script>
<style lang="less" scoped>
.is-error /deep/ .es-input__inner {
  border-color: #f56c6c;
}
.body {
  height: 400px;
  overflow: auto;
}
.header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
  margin-bottom: 10px;
  line-height: 40px;
  > div {
    cursor: pointer;
    padding: 0 10px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 12px;
    color: #191f28;
    background: #ffffff;
    margin-right: 20px;
    border: 1px solid #eaebee;
  }
  .active {
    border: 1px solid #0975e0ff;
    position: relative;
  }
  .active::before {
    content: '';
    position: absolute;
    right: -1px;
    bottom: 0px;
    width: 0px;
    height: 0px;
    border-color: #0975e0ff transparent;
    border-width: 0px 0px 15px 15px;
    border-style: solid;
  }
  .active::after {
    content: '';
    position: absolute;
    right: -1px;
    bottom: 2px;
    width: 10px;
    height: 4px;
    border: 2px solid #fff;
    border-radius: 1px;
    border-top: none;
    border-right: none;
    background: transparent;
    transform: rotate(-45deg);
  }
}
.change-multiple {
  margin-bottom: 20px;
  > div {
    display: flex;
    align-items: center;
    margin-top: 10px;
    justify-content: flex-end;
    span {
      color: rgba(0, 0, 0, 0.25);
      font-size: 12px;
    }
  }
}
.footer {
  padding: 20px 0;
  display: flex;
  flex-direction: row-reverse;
  justify-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    align-items: center;
  }
}
/deep/.selected-row {
  background: #edf5fd !important;
}

.width-200 {
  width: 200px;
  margin: 0 10px;
}
/deep/ .es-checkbox__input.is-disabled .es-checkbox__inner::after {
  transform: rotate(45deg) scaleY(1);
}
/deep/.es-empty__image {
  width: 64px;
}
</style>
